<template>
  <div class="news">
    <NewsBanner />
    <div class="news-box">
      <div class="news-header">
        <span :class="active === 'news' ? 'label-selected' : 'label-normal'" @click="active='news'">新闻</span>
        <span :class="active === 'activity' ? 'label-selected' : 'label-normal'"
              @click="active='activity'" style="margin-left: 72px">活动</span>
      </div>
      <div class="news-container">
        <div v-show="active === 'news'" v-for="item in news" class="news-item" :key="item.id" @click="handleItemClick(item.url)">
          <img :src="item.img"/>
          <div class="news-description">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
          </div>
        </div>
        <div v-show="active === 'activity'" v-for="item in activities" class="news-item" :key="item.id" @click="handleItemClick(item.url)">
          <img :src="item.img"/>
          <div class="news-description">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NewsBanner from './NewsBanner'
	export default {
		name: 'news',
    components: {
      NewsBanner
    },
    data() {
      return {
        active: 'news',
        news: [
        {
            id: 117,
            title: '全媒体总裁专访 | MoPaaS魔泊云创始人、CEO鲁为民：大模型时代助力高校的科研、教学、实验的人才培养',
            time: '2024-05-22',
            img: require('@/assets/images/news-20240522.png'),
            url: 'https://mp.weixin.qq.com/s/fhE67NnmC6WfwEybT7u6xQ'
          },  
          {
            id: 116,
            title: 'MoPaaS 魔泊云获得吴文俊人工智能科学技术科技进步奖',
            time: '2024-04-07',
            img: require('@/assets/images/news-20240407.png'),
            url: 'https://mp.weixin.qq.com/s/WqnLWldNQaEKVS6-UgcZbA'
          },  
          {
            id: 115,
            title: 'Sora的狂欢、世界模型和AGI',
            time: '2024-02-29',
            img: require('@/assets/images/news-20240229.png'),
            url: 'https://mp.weixin.qq.com/s/wLo-U6yETJnlPtN-dTk66g'
          },
          {
            id: 114,
            title: '大模型时代的智能体 (III)：构建基于LLM 的智能体',
            time: '2023-10-27',
            img: require('@/assets/images/news-20231027.png'),
            url: 'https://mp.weixin.qq.com/s/z0VrH5MXwDydgaGlTDwkFg'
          },
          {
            id: 113,
            title: '大模型时代的智能体 (II)：为什么是LLMs？',
            time: '2023-10-20',
            img: require('@/assets/images/news-20231020.png'),
            url: 'https://mp.weixin.qq.com/s/2sthQB_ierog6fk4ZUFNRA'
          },
          {
            id: 112,
            title: '大模型时代的智能体 (I)：什么是智能体？',
            time: '2023-10-13',
            img: require('@/assets/images/news-20231013.jpg'),
            url: 'https://mp.weixin.qq.com/s/tcX0B-pJi9NLrKC6XJnmVQ'
          },
          {
            id: 111,
            title: '快捷高效| 通过 MoPaaS AI 平台完成 YOLOv5 训练',
            time: '2023-09-18',
            img: require('@/assets/images/news-20230918.png'),
            url: 'https://mp.weixin.qq.com/s/w8BGEAc2bEpTdtuKbNRgOA'
          },
          {
            id: 110,
            title: 'MoPaaS 魔泊云首批入驻上海昇思AI框架&大模型创新中心',
            time: '2023-06-20',
            img: require('@/assets/images/news-20230620.png'),
            url: 'https://mp.weixin.qq.com/s/qDUGtdkBeCYEBrmDr52bVQ'
          },
          {
            id: 109,
            title: '同心同行，莫负春光，MoPaaS魔泊云团建嗨翻了',
            time: '2023-04-24',
            img: require('@/assets/images/news-20230424.png'),
            url: 'https://mp.weixin.qq.com/s/HDjJNoXLTPU5HaSRAwUNEQ'
          },
          {
            id: 108,
            title: '人工智能企业应用和工程挑战沙龙完美收官',
            time: '2022-12-15',
            img: require('@/assets/images/news-20221215.png'),
            url: 'https://mp.weixin.qq.com/s/3DQyEUi5EeiUyuZy369Crw'
          },
          {
            id: 107,
            title: 'MoPaaS魔泊云获奖“2022昇腾AI创新大赛”，信创领域新突破',
            time: '2022-10-25',
            img: require('@/assets/images/news-20221025.png'),
            url: 'https://mp.weixin.qq.com/s/M-56sGBHuno21r2lqYlGWA'
          },
          {
            id: 106,
            title: '“人工智能技术发展和挑战：人才、算力和工程的考虑 ”，MoPaaS 人工智能沙龙完美收官',
            time: '2022-09-15',
            img: require('@/assets/images/news-20220915.png'),
            url: 'https://mp.weixin.qq.com/s/K5-dOxsIiwBTW_PfD2sl3A'
          },
          {
            id: 105,
            title: '上海殷泊信息科技有限公司创始人和CEO鲁为民博士接受中教全媒体采访',
            time: '2022-08-24',
            img: require('@/assets/images/news-20220824.png'),
            url: 'https://mp.weixin.qq.com/s/_41WzeII1S20L6_Bc-cXHw'
          },
          {
            id: 104,
            title: 'MoPaaS魔泊云受邀出席第三届中国人工智能教育大会，创始人和CEO分享“人工智能工程基础和教育“主旨演讲！',
            time: '2022-08-05',
            img: require('@/assets/images/news-20220805.png'),
            url: 'https://mp.weixin.qq.com/s/dTRqcbB7WREndARmh8leFQ'
          },
          {
            id: 103,
            title: 'MoPaaS人工智能线上沙龙圆满落幕',
            time: '2021-07-12',
            img: require('@/assets/images/news-20210712.png'),
            url: 'https://mp.weixin.qq.com/s/Y81dDqqSGhKWRsemuv9pGw'
          },
          {
            id: 102,
            title: 'MoPaaS魔泊云亮相中国人工智能教育大会',
            time: '2021-04-27',
            img: require('@/assets/images/news-20210427.png'),
            url: 'https://mp.weixin.qq.com/s/ND8pSIkNYXl004K7Jkajrw'
          },
          {
            id: 101,
            title: 'MoPaaS布局信创产业，与华为鲲鹏、昇腾完成兼容互认证！',
            time: ' 2021-01-29',
            img: require('@/assets/images/news-20210129.png'),
            url: 'https://mp.weixin.qq.com/s/3QCbh8xnrjU6AX-n4HR1mg'
          },
          {
            id: 100,
            title: 'MoPaaS参加上海市人工智能学会2021学术大会',
            time: '2021-01-15',
            img: require('@/assets/images/news-20210115.png'),
            url: 'https://mp.weixin.qq.com/s/zw32CgGMc5srrUN29Kr46Q'
          }
        ],
        activities: [
        {
            id: 211,
            title: 'MoPaaS魔泊云受邀参加2024全球人工智能技术博览会',
            time: '2024-06-28',
            img: require('@/assets/images/activity-20240628.png'),
            url: 'https://mp.weixin.qq.com/s/rQN3L7iU_kk5BcyGtzUicg'
          },
          {
            id: 210,
            title: 'MoPaaS邀您参加2024全球人工智能技术博览会',
            time: '2024-06-20',
            img: require('@/assets/images/activity-20240620.png'),
            url: 'https://mp.weixin.qq.com/s/Sq6-ThCOUlXlSmWWe2eoYw'
          },
          {
            id: 209,
            title: 'MoPaaS魔泊云受邀参加吴文俊人工智能科学技术奖颁奖典礼并接受吴文俊奖',
            time: '2024-04-24',
            img: require('@/assets/images/activity-20240424.png'),
            url: 'https://mp.weixin.qq.com/s/aD914YQGKpovNZhdMnVHAA'
          },
          {
            id: 208,
            title: 'MoPaaS魔泊云出席第五届中国人工智能教育大会, 并发表“大模型时代的人工智能教学实验管理“主旨演讲！',
            time: '2024-04-23',
            img: require('@/assets/images/activity-20240423.png'),
            url: 'https://mp.weixin.qq.com/s/xMByqKQdbotxw0-TFG4biA'
          },
          {
            id: 207,
            title: 'MoPaaS魔泊云邀您共赴北京参加第五届中国人工智能教育大会',
            time: '2024-04-12',
            img: require('@/assets/images/activity-20240412.png'),
            url: 'https://mp.weixin.qq.com/s/zGLv3TyWp1mEKmFj7qcMWQ'
          },
          {
            id: 206,
            title: '深度对话产业专家：“百模大战”愈演愈烈，地球上现有算力不够支撑十亿人使用',
            time: '2023-05-09',
            img: require('@/assets/images/activity-20230509.png'),
            url: 'https://mp.weixin.qq.com/s/9vCKaoFqE1SDkY3TaSTCWg'
          },
          {
            id: 205,
            title: '邀请函||MoPaaS邀请您参加人工智能企业应用和工程挑战线上沙龙',
            time: '2022-12-08',
            img: require('@/assets/images/activity-20221208.png'),
            url: 'https://mp.weixin.qq.com/s/6aFKGq_t8oaeR4ASOeFOtQ'
          },
          {
            id: 204,
            title: '邀请函||人工智能技术发展和工程挑战',
            time: '2022-09-04',
            img: require('@/assets/images/activity-20220904.png'),
            url: 'https://mp.weixin.qq.com/s/2n55DllPZfnIfJc7ajsaIw'
          },
          {
            id: 203,
            title: 'MoPaaS魔泊云邀您同赴厦门参加第三届中国人工智能教育大会',
            time: '2022-07-29',
            img: require('@/assets/images/activity-20220729.png'),
            url: 'https://mp.weixin.qq.com/s/7bpU9VnzUp0BDniOOphJgQ'
          },
          {
            id: 202,
            title: '邀请函||人工智能赋能数字化未来线上沙龙',
            time: '2022-05-09',
            img: require('@/assets/images/activity-20220509.png'),
            url: 'https://mp.weixin.qq.com/s/S8_sjIBOFi7zc8Woc36FNw'
          },
          {
            id: 201,
            title: '邀约‖MoPaaS邀您明日共赴苏州智博会（内附报名入口）',
            time: '2021-09-15',
            img: require('@/assets/images/activity-20210915.png'),
            url: 'https://mp.weixin.qq.com/s/dm7duqApx22K2O_xp_eRjg'
          },
          {
            id: 200,
            title: '邀您参加"MoPaaS魔泊云人工智能线上沙龙"',
            time: '2021-07-05',
            img: require('@/assets/images/activity-20210705.png'),
            url: 'https://mp.weixin.qq.com/s/CST5B88yEagOjzl4NZ4KXA'
          },
        ]
      }
    },
    methods: {
      handleItemClick(url) {
        if(url !== '' && url !== null) {
          window.open(url,"_blank");
        }
      }
    },
    mounted() {
      console.log('=== news ===',this.$route.query)
      if(this.$route.query.type) {
        this.active = this.$route.query.type !== '2' ? 'news':'activity';
      }
    }
  }
</script>

<style>
  @media (min-width: 992px) {
    .news .news-box .news-header {
      width: 100%;
      height: 78px;
      background: #FFFFFF;
      box-shadow: 0px 2px 15px 0px rgba(15,34,95,0.06);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 260px;
    }
    .news .news-box .news-header .label-normal {
      width: 52px;
      height: 26px;
      font-size: 26px;
      font-weight: 400;
      color: #060D27;
      line-height: 26px;
      cursor: pointer;
    }
    .news .news-box .news-header .label-selected {
      width: 52px;
      height: 26px;
      font-size: 26px;
      font-weight: 600;
      color: #34A6FF;
      line-height: 26px;
      cursor: pointer;
    }
    .news .news-box .news-container {
      margin: 120px auto;
    }
    .news .news-box .news-container .news-item {
      width: 1332px;
      height: 194px;
      background: #F5F6F9;
      padding: 0 34px;
      margin: 0 auto 42px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
    }
    .news .news-box .news-container .news-item img {
      width: 215px;
      height: 126px;
    }
    .news .news-box .news-container .news-item .news-description {
      width: 1083px;
      height: 126px;
      position: relative;
    }
    .news-item .news-description .title {
      width: 100%;
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      text-align: left;
    }
    .news-item .news-description .time {
      height: 22px;
      font-size: 22px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      position: absolute;
      bottom: 0;
      opacity: 0.49;
    }
  }
  @media (max-width: 992px) {
    .news .news-box .news-header {
      width: 100vw;
      height: 14vw;
      background: #FFFFFF;
      box-shadow: 0px 2px 15px 0px rgba(15,34,95,0.06);
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .news .news-box .news-header .label-normal {
      font-size: 20px;
      font-weight: 400;
      color: #060D27;
      line-height: 24px;
      cursor: pointer;
    }
    .news .news-box .news-header .label-selected {
      font-size: 20px;
      font-weight: 600;
      color: #34A6FF;
      line-height: 24px;
      cursor: pointer;
    }
    .news .news-box .news-container {
      margin: 6vw auto 18vw;
    }
    .news .news-box .news-container .news-item {
      width: 76vw;
      height: 36vw;
      background: #F5F6F9;
      padding: 2vw 6vw;
      margin: 0 auto 6vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
    }
    .news .news-box .news-container .news-item img {
      width: 215px;
      height: 126px;
      display: none;
    }
    .news .news-box .news-container .news-item .news-description {
      width: 76vw;
      height: 30vw;
      position: relative;
    }
    .news-item .news-description .title {
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      text-align: left;
    }
    .news-item .news-description .time {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      position: absolute;
      bottom: 0;
      opacity: 0.49;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/News.vue